<script lang="ts">
  import SmallPoem from './SmallPoem.svelte'
  import type {Poem} from '../types'
  import LoadMore from '../shared/LoadMore.svelte'

  export let url: string
  export let title: string
  export let emptyPlaceholder: string

  let poems: Poem[] = []
</script>

<div class="row">
  <div class="grid-section">
    <div class="heading">
      <h2>{title}</h2>
    </div>

    {#if !poems.length}
      <div class="empty-section tc">{emptyPlaceholder}</div>
    {:else}
      <div class="grid three">
        {#each poems as poem}
          {#if poem}
            <div class="grid__item">
              <SmallPoem {poem}/>
            </div>
          {/if}
        {/each}
      </div>
    {/if}

    <LoadMore {url} bind:items={poems}/>
  </div>
</div>
